// extracted by mini-css-extract-plugin
module.exports = {"mobile":"0","tablet":"1300","desktop":"1366"};